import { defineComponent, ref } from "vue";
import { api } from "~/api/Api";
import { FindBankBranchCommand } from "~/api/Common/Commands/FindBankBranchCommand";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
const log = Log.create("TaikyoForInputArea");
export default defineComponent({
    name: "BranchDialog",
    emits: ["close", "select", "back"],
    props: {
        bank: { type: Object, required: true }
    },
    setup(props, { emit }) {
        const allBranchList = ref([]);
        const displayBranchList = ref([]);
        const searchBranch = ref("");
        // 検索フラグ(true:検索、false:未検索)
        const isSearch = ref(false);
        // データ存在フラグ(true:データなし、false:データあり)
        const isDataNotFound = ref(false);
        // 支店検索APIレスポンス取得フラグ(true:レスポンス取得、false:レスポンス未取得)
        const isBranchLoaded = ref(false);
        // 支店検索API失敗フラグ(true:API失敗、false:API成功)
        const isError = ref(false);
        const findBankBranchCommand = new FindBankBranchCommand();
        // 閉じるボタン
        const closeDialog = () => {
            emit("close");
        };
        const back = () => {
            emit("back");
        };
        //検索ボタン
        const onSearch = async () => {
            isSearch.value = true;
            isDataNotFound.value = false;
            // APIのレスポンスが返ってきていな場合
            if (!isBranchLoaded.value) {
                return;
            }
            // 支店検索APIが失敗した場合
            if (isError.value) {
                isSearch.value = false;
                isDataNotFound.value = true;
                await MsgBox.error(commonStore.messages.PE0001);
                return;
            }
            // 支店検索APIのレスポンスが0の場合、以降の処理を行わない
            if (allBranchList.value.length === 0) {
                isSearch.value = false;
                isDataNotFound.value = true;
                return;
            }
            const text = searchBranch.value.trim();
            if (text === "") {
                displayBranchList.value = [];
                isDataNotFound.value = true;
            }
            else {
                displayBranchList.value = allBranchList.value.filter(branch => branch.name.includes(text));
                // 検索結果が1件以上ある場合、データ未存在フラグをfalseにする
                isDataNotFound.value = displayBranchList.value.length === 0;
            }
            isSearch.value = false;
        };
        const onRowClick = (branch) => {
            emit("select", {
                bank: props.bank,
                branch: branch
            });
        };
        const initView = async () => {
            try {
                findBankBranchCommand.bankCd = props.bank.code;
                let result = await api.common.findBankBranch(findBankBranchCommand);
                allBranchList.value = result.banks?.[0]?.branches ?? [];
                isBranchLoaded.value = true;
                // 支店情報取得後、検索済みの場合、検索処理を実行
                if (isSearch.value) {
                    onSearch();
                }
            }
            catch (ex) {
                log.error("setup", ex);
                await MsgBox.error(commonStore.messages.PE0001);
                isBranchLoaded.value = true;
                isError.value = true;
                isDataNotFound.value = true;
            }
        };
        initView();
        return {
            closeDialog,
            allBranchList,
            displayBranchList,
            searchBranch,
            onSearch,
            onRowClick,
            back,
            isSearch,
            isDataNotFound
        };
    }
});
